
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/g2-grid-report-cdp",
      function () {
        return require("private-next-pages/g2-grid-report-cdp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/g2-grid-report-cdp"])
      });
    }
  